import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { StyledCard } from '../../../../common/base/Card';
import Container from '../../../../common/base/Container';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import SwitchInput from '../../../../common/Form/Fields/SwitchInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { DashboardContext } from '../../DashboardContext';
import Icon from '../../../../common/base/Icon';
const OrganizationSecurity: React.FC = () => {
  const $ = _c(13);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    organization,
    organization_role,
    mutateOrganization
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  const is_admin = organization_role === "owner" || organization_role === "admin";
  let t0;
  if ($[0] !== HookdeckAPI.organizations || $[1] !== addToast || $[2] !== mutateOrganization || $[3] !== organization) {
    t0 = values => HookdeckAPI.organizations.updateSecurity(values).then(security_settings => {
      addToast("success", "Security settings updated");
      mutateOrganization({
        ...organization,
        mfa_required: security_settings.mfa_required
      });
      return true;
    }).catch(() => {
      addToast("error", "Failed to update security settings");
    });
    $[0] = HookdeckAPI.organizations;
    $[1] = addToast;
    $[2] = mutateOrganization;
    $[3] = organization;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const handleSubmit = t0;
  let t1;
  if ($[5] !== organization.mfa_required) {
    t1 = {
      mfa_required: organization.mfa_required
    };
    $[5] = organization.mfa_required;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== is_admin) {
    t2 = props => <Form><Text bold={true} size="l" as="h2" m={{
        t: 0,
        b: 4
      }}>Security</Text><StyledCard p={{
        x: 4,
        y: 3
      }} w={100} flex={{
        justify: "flex-start",
        align: "center",
        gap: 3
      }}><Tooltip disabled={is_admin} tooltip="Only organization admins can change security settings"><SwitchInput name="mfa_required" disabled={!is_admin} onChange={() => is_admin && props.submitForm()} /></Tooltip><Div w={100} flex={{
          align: "center"
        }}><Text>Require MFA for all members </Text><Tooltip tooltip="When enabled, all organization members will be required to set up multi-factor authentication before accessing the dashboard."><Icon icon="info" right={true} /></Tooltip></Div></StyledCard></Form>;
    $[7] = is_admin;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== handleSubmit || $[10] !== t1 || $[11] !== t2) {
    t3 = <Container medium={true} left={true}><Formik initialValues={t1} onSubmit={handleSubmit}>{t2}</Formik></Container>;
    $[9] = handleSubmit;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default OrganizationSecurity;